import React from "react"
import Footer from "../Components/Outlets/Footer"
import Nav from "../Components/Outlets/Nav"
import AdmissionForm from "./AdmissionForm"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"

const steps = [
	{
		number: "01",
		title: "Apply",
		text: "Share student, parent, and academic details through the admission form.",
	},
	{
		number: "02",
		title: "Counseling",
		text: "Meet the academic team to choose the right stream and career pathway.",
	},
	{
		number: "03",
		title: "Confirm",
		text: "Complete joining formalities and reserve the seat for the selected program.",
	},
]

const documents = [
	"Recent passport-size photo",
	"Birth certificate or Aadhaar",
	"Previous school records",
	"Parent or guardian contact details",
]

const Admission = () => {
	return (
		<div className="admission-page-shell">
			<Nav />

			<section className="inner-hero admission-hero">
				<div className="container-main">
					<motion.div
						className="inner-hero-content"
						initial={{ opacity: 0, y: 35 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.75 }}
					>
						<span className="inner-eyebrow">Admissions</span>
						<h1 className="inner-hero-title montserrat">Begin a focused path to global careers</h1>
						<p className="inner-hero-copy">
							Apply for Le Fille Global School and take the next step toward integrated academics,
							entrance preparation, and guided career growth.
						</p>
						<div className="inner-hero-actions">
							<a href="#application-form" className="hero-primary-btn">
								Fill Application <i className="ri-arrow-down-line"></i>
							</a>
							<Link to="/contact" className="hero-secondary-btn">
								Talk to Us
							</Link>
						</div>
					</motion.div>
				</div>
			</section>

			<main className="admission-redesign">
				<section className="admission-overview-section">
					<div className="container-main">
						<div className="section-heading-row">
							<div>
								<span className="section-eyebrow">Admission Journey</span>
								<h2 className="section-title montserrat">Clear, guided, and parent-friendly</h2>
							</div>
							<p className="section-copy">
								The admission team helps families understand program options, eligibility,
								and the right preparation track for each student.
							</p>
						</div>

						<div className="row g-4">
							{steps.map((step, index) => (
								<div className="col-lg-4 col-md-6" key={step.number}>
									<motion.div
										className="admission-step-panel"
										initial={{ opacity: 0, y: 24 }}
										whileInView={{ opacity: 1, y: 0 }}
										viewport={{ once: true }}
										transition={{ duration: 0.55, delay: index * 0.08 }}
									>
										<span>{step.number}</span>
										<h3>{step.title}</h3>
										<p>{step.text}</p>
									</motion.div>
								</div>
							))}
						</div>
					</div>
				</section>

				<section className="admission-form-section" id="application-form">
					<div className="container-main">
						<div className="admission-form-layout">
							<aside className="admission-support-panel">
								<span className="section-eyebrow">Before You Apply</span>
								<h2 className="section-title montserrat">Keep these details ready</h2>
								<p className="section-copy">
									The form may ask for student information, previous school details, and parent contact
									information. Keep the basics nearby so the application stays smooth.
								</p>
								<div className="document-list">
									{documents.map((item) => (
										<div className="document-item" key={item}>
											<i className="ri-file-list-3-line"></i>
											<span>{item}</span>
										</div>
									))}
								</div>
								<div className="admission-help-box">
									<i className="ri-customer-service-2-line"></i>
									<div>
										<strong>Need guidance?</strong>
										<p>Our team can help you choose the right stream and preparation pathway.</p>
									</div>
								</div>
							</aside>

							<div className="admission-form-column">
								<AdmissionForm />
							</div>
						</div>
					</div>
				</section>
			</main>

			<Footer />
		</div>
	)
}

export default Admission
